import React from 'react';

export default function Avatar({ src, alt, size = 32, className = '' }) {
  return src ? (
    <img src={src} alt={alt} className={`rounded-full object-cover`} style={{width: size, height: size}} />
  ) : (
    <div className={`rounded-full bg-blue-gray-200 flex items-center justify-center text-blue-gray-500 font-heading font-bold`} style={{width: size, height: size}}>
      {alt?.[0]?.toUpperCase() || '?'}
    </div>
  );
} 